import failed from "../../../assets/images/status/wrong.gif";
import success from "../../../assets/images/status/success.gif";
import style from "./Popup.module.css";

function Popup(props) {
  return (
    <div className={style.main_popup} style={props.style && props.style}>
      <div className={` ${style.card}`}>
        <h1 className={style.head}>{props.head}</h1>
        {
          props.err && <>
          {props.err === "yes" ? <img src={failed} width="100px" /> : <img src={success} width="100px" />}
        </>
        }
        
        <p className={style.msg}>{props.msg && props.msg }</p>
        <button className={style.btn} onClick={() => props.oKFunc()}>
          Ok
        </button>
      </div>
    </div>
  );
}

export default Popup;
